import * as React from "react";
import { Context, CartSlider, Cart } from "@grandvisionhq/carts-v2";
import { MediaQuery } from "@grandvisionhq/common";
import { useLink } from "@grandvisionhq/frk-routing";
import { PaymentFlow } from "@grandvisionhq/payments";
import { useSelector } from "@grandvisionhq/state";
import { getSelectedDonation } from "../../selectors.js";
import { StepNames } from "../../models/models/shared.js";
const CheckoutCart = ({
  currentStep,
  isFinishedCheckout,
  orderData,
  paymentFlow,
  selectedPaymentMethodPrice
}) => {
  const isOverviewStep = currentStep === StepNames.Overview;
  const { cart, loading, error } = Context.useCart();
  const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
  const { onClick: navigateToHomePage } = useLink({ route: "home" }, { replace: true }) || {};
  const selectedDonation = useSelector(getSelectedDonation);
  const { onClick: navigateToCart } = useLink({ route: "cart.overview" }, { replace: true }) || {};
  React.useEffect(() => {
    if (cart && !cart.lineItems?.length && !isFinishedCheckout && paymentFlow !== PaymentFlow.QR_CODE) {
      console.error(`Cart went empty during checkout, returning to homepage`);
      navigateToHomePage?.();
    }
  }, [cart, cart?.lineItems?.length, isFinishedCheckout, paymentFlow, navigateToHomePage]);
  React.useEffect(() => {
    if (!loading && error) {
      navigateToCart?.();
    }
  }, [loading, error]);
  if (!orderData && isFinishedCheckout) {
    return null;
  }
  const Wrapper = isSmallScreen && !isOverviewStep ? CartSlider : React.Fragment;
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(
    Cart,
    {
      selectedPaymentMethodPrice,
      ...selectedDonation?.amount && {
        donation: { amount: selectedDonation?.amount, key: selectedDonation?.key }
      }
    }
  ));
};
export {
  CheckoutCart
};
//# sourceMappingURL=CheckoutCart.js.map
